import { Apiv2ServiceException as __BaseException } from "../models/Apiv2ServiceException";
import { AutoTestSetupStepInput, AutoTestTestStepInput, BadRequestError, InternalServerError, NotAuthenticatedError, NotAuthorizedError, NotFoundError, ValidationError, } from "../models/models_0";
import { awsExpectUnion as __expectUnion, loadRestJsonErrorCode, parseJsonBody as parseBody, parseJsonErrorBody as parseErrorBody, } from "@aws-sdk/core";
import { requestBuilder as rb } from "@smithy/core";
import { decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectInt32 as __expectInt32, expectNonNull as __expectNonNull, expectObject as __expectObject, expectString as __expectString, parseRfc3339DateTimeWithOffset as __parseRfc3339DateTimeWithOffset, _json, collectBody, isSerializableHeaderValue, map, take, withBaseException, } from "@smithy/smithy-client";
/**
 * serializeAws_restJson1CreateAssistantCommand
 */
export const se_CreateAssistantCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/assistants");
    let body;
    body = JSON.stringify(take(input, {
        'data': _ => _json(_),
        'name': [],
        'status': _ => _json(_),
        'systemPrompt': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1CreateAssistantConversationCommand
 */
export const se_CreateAssistantConversationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/assistants/{assistantId}/conversations");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'initialMessage': _ => _json(_),
        'owner': [],
        'title': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1CreateAssistantMessageCommand
 */
export const se_CreateAssistantMessageCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/assistants/{assistantId}/conversations/{conversationId}/messages");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    b.p('conversationId', () => input.conversationId, '{conversationId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'content': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1GetAssistantCommand
 */
export const se_GetAssistantCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/assistants/{assistantId}");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1GetAssistantConversationCommand
 */
export const se_GetAssistantConversationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/assistants/{assistantId}/conversations/{conversationId}");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    b.p('conversationId', () => input.conversationId, '{conversationId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1GetAssistantMessageCommand
 */
export const se_GetAssistantMessageCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/assistants/{assistantId}/conversations/{conversationId}/messages/{messageId}");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    b.p('conversationId', () => input.conversationId, '{conversationId}', false);
    b.p('messageId', () => input.messageId, '{messageId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1ListAssignmentAssistantsCommand
 */
export const se_ListAssignmentAssistantsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => isSerializableHeaderValue(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/assignments/{assignmentId}/assistants");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1ListAssistantMessagesCommand
 */
export const se_ListAssistantMessagesCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => isSerializableHeaderValue(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/assistantId/{assistantId}/conversations/{conversationId}/messages");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    b.p('conversationId', () => input.conversationId, '{conversationId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1ListUserAssistantConversationsCommand
 */
export const se_ListUserAssistantConversationsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => isSerializableHeaderValue(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/users/{userId}/conversations");
    b.p('userId', () => input.userId, '{userId}', false);
    const query = map({
        [_aI]: [, __expectNonNull(input[_aI], `assignmentId`)],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1UpdateAssistantCommand
 */
export const se_UpdateAssistantCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/assistants/{assistantId}");
    b.p('assistantId', () => input.assistantId, '{assistantId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'name': [],
        'status': _ => _json(_),
        'systemPrompt': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1CopyAutoTestConfigurationCommand
 */
export const se_CopyAutoTestConfigurationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/autotest/{assignmentId}/copy");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'dstAssignmentId': [],
        'overwriteRubric': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1CreateAutoTestSnapshotCommand
 */
export const se_CreateAutoTestSnapshotCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}/snapshots");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1DeleteAutoTestConfigurationCommand
 */
export const se_DeleteAutoTestConfigurationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("DELETE")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1GetAutoTestConfigurationCommand
 */
export const se_GetAutoTestConfigurationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1GetAutoTestPublishedSnapshotCommand
 */
export const se_GetAutoTestPublishedSnapshotCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}/published-snapshot");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1GetAutoTestSnapshotCommand
 */
export const se_GetAutoTestSnapshotCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}/snapshots/{snapshotId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    b.p('snapshotId', () => input.snapshotId, '{snapshotId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1ListAutoTestSnapshotsCommand
 */
export const se_ListAutoTestSnapshotsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => isSerializableHeaderValue(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/autotest/{assignmentId}/snapshots");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1PutAutoTestConfigurationCommand
 */
export const se_PutAutoTestConfigurationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/autotest/{assignmentId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1UpdateAutoTestConfigurationCommand
 */
export const se_UpdateAutoTestConfigurationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/autotest/{assignmentId}");
    b.p('assignmentId', () => input.assignmentId, '{assignmentId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'publishedSnapshot': _ => _json(_),
        'updatedSetup': _ => se_AutoTestSetupConfigurationInput(_, context),
        'updatedTest': _ => se_AutoTestTestConfigurationInput(_, context),
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1CreateEditorSessionCommand
 */
export const se_CreateEditorSessionCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/editor-sessions");
    let body;
    body = JSON.stringify(take(input, {
        'assignmentId': [],
        'name': [],
        'owner': [],
        'source': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1HandInEditorSessionCommand
 */
export const se_HandInEditorSessionCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/editors-sessions/{editorSessionId}/hand-in");
    b.p('editorSessionId', () => input.editorSessionId, '{editorSessionId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'ignoreNonInteractedQuestions': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1ListEditorSessionsCommand
 */
export const se_ListEditorSessionsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        [_xnt]: input[_nT],
        [_xps]: [() => isSerializableHeaderValue(input[_pS]), () => input[_pS].toString()],
    });
    b.bp("/users/{userId}/editor-sessions");
    b.p('userId', () => input.userId, '{userId}', false);
    const query = map({
        [_aI]: [, __expectNonNull(input[_aI], `assignmentId`)],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1PutEditorFileCommand
 */
export const se_PutEditorFileCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/editor-sessions/{editorSessionId}/files");
    b.p('editorSessionId', () => input.editorSessionId, '{editorSessionId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'fileType': _ => _json(_),
        'path': [],
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1GetPearsonContextTemplateCommand
 */
export const se_GetPearsonContextTemplateCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/courses/{contextId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1GetPearsonContextTemplateQuestionCommand
 */
export const se_GetPearsonContextTemplateQuestionCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/context/{contextId}/questions/{questionId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    b.p('questionId', () => input.questionId, '{questionId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1InstantiatePearsonTemplateCommand
 */
export const se_InstantiatePearsonTemplateCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/instantiate");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'dstAssignmentId': [],
        'questionsMapping': _ => _json(_),
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1PutPearsonBookCommand
 */
export const se_PutPearsonBookCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-books/{bookId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('bookId', () => input.bookId, '{bookId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'author': [],
        'buildAssignmentId': [],
        'language': [],
        'tags': _ => _json(_),
        'year': [],
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1PutPearsonContextTemplateCommand
 */
export const se_PutPearsonContextTemplateCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/courses/{contextId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    let body;
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1PutPearsonQuestionCommand
 */
export const se_PutPearsonQuestionCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/questions/{questionId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('questionId', () => input.questionId, '{questionId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'name': [],
        'source': _ => _json(_),
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1PutPearsonTemplateCommand
 */
export const se_PutPearsonTemplateCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'bookId': [],
        'name': [],
        'runSingleQuestions': [],
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1UpdatePearsonContextTemplateCommand
 */
export const se_UpdatePearsonContextTemplateCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/context/{contextId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'numberOfAttempts': _ => _json(_),
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1UpdatePearsonContextTemplateQuestionCommand
 */
export const se_UpdatePearsonContextTemplateQuestionCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/tenants/{tenantId}/pearson-templates/{templateId}/context/{contextId}/questions/{questionId}");
    b.p('tenantId', () => input.tenantId, '{tenantId}', false);
    b.p('templateId', () => input.templateId, '{templateId}', false);
    b.p('contextId', () => input.contextId, '{contextId}', false);
    b.p('questionId', () => input.questionId, '{questionId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'enabled': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * serializeAws_restJson1CreateSafeProgramCommand
 */
export const se_CreateSafeProgramCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/safe-program");
    let body;
    body = JSON.stringify(take(input, {
        'source': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
/**
 * deserializeAws_restJson1CreateAssistantCommand
 */
export const de_CreateAssistantCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.assistant = _json(data);
    return contents;
};
/**
 * deserializeAws_restJson1CreateAssistantConversationCommand
 */
export const de_CreateAssistantConversationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.conversation = de_AssistantConversation(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1CreateAssistantMessageCommand
 */
export const de_CreateAssistantMessageCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.message = de_AssistantMessage(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1GetAssistantCommand
 */
export const de_GetAssistantCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.assistant = _json(data);
    return contents;
};
/**
 * deserializeAws_restJson1GetAssistantConversationCommand
 */
export const de_GetAssistantConversationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.conversation = de_AssistantConversation(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1GetAssistantMessageCommand
 */
export const de_GetAssistantMessageCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.message = de_AssistantMessage(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1ListAssignmentAssistantsCommand
 */
export const de_ListAssignmentAssistantsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'assistants': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
/**
 * deserializeAws_restJson1ListAssistantMessagesCommand
 */
export const de_ListAssistantMessagesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'messages': _ => de_AssistantMessages(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
/**
 * deserializeAws_restJson1ListUserAssistantConversationsCommand
 */
export const de_ListUserAssistantConversationsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'conversations': _ => de_AssistantConversations(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
/**
 * deserializeAws_restJson1UpdateAssistantCommand
 */
export const de_UpdateAssistantCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.assistant = _json(data);
    return contents;
};
/**
 * deserializeAws_restJson1CopyAutoTestConfigurationCommand
 */
export const de_CopyAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
/**
 * deserializeAws_restJson1CreateAutoTestSnapshotCommand
 */
export const de_CreateAutoTestSnapshotCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.snapshot = de_AutoTestSnapshotSummary(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1DeleteAutoTestConfigurationCommand
 */
export const de_DeleteAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
/**
 * deserializeAws_restJson1GetAutoTestConfigurationCommand
 */
export const de_GetAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.configuration = de_AutoTestConfiguration(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1GetAutoTestPublishedSnapshotCommand
 */
export const de_GetAutoTestPublishedSnapshotCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.snapshot = de_AutoTestPublishedSnapshot(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1GetAutoTestSnapshotCommand
 */
export const de_GetAutoTestSnapshotCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.snapshot = de_AutoTestSnapshot(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1ListAutoTestSnapshotsCommand
 */
export const de_ListAutoTestSnapshotsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'snapshots': _ => de_AutoTestSnapshotSummaries(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
/**
 * deserializeAws_restJson1PutAutoTestConfigurationCommand
 */
export const de_PutAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.configuration = de_AutoTestConfiguration(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1UpdateAutoTestConfigurationCommand
 */
export const de_UpdateAutoTestConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.configuration = de_AutoTestConfiguration(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1CreateEditorSessionCommand
 */
export const de_CreateEditorSessionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'editorSession': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
/**
 * deserializeAws_restJson1HandInEditorSessionCommand
 */
export const de_HandInEditorSessionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'editorSubmission': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
/**
 * deserializeAws_restJson1ListEditorSessionsCommand
 */
export const de_ListEditorSessionsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
        [_nT]: [, output.headers[_xnt]],
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'editorSessions': _ => de_EditorSessions(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
/**
 * deserializeAws_restJson1PutEditorFileCommand
 */
export const de_PutEditorFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.file = de_OutputEditorFile(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1GetPearsonContextTemplateCommand
 */
export const de_GetPearsonContextTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.contextTemplate = _json(data);
    return contents;
};
/**
 * deserializeAws_restJson1GetPearsonContextTemplateQuestionCommand
 */
export const de_GetPearsonContextTemplateQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.question = de_PearsonContextTemplateQuestion(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1InstantiatePearsonTemplateCommand
 */
export const de_InstantiatePearsonTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'rubricRowLock': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
/**
 * deserializeAws_restJson1PutPearsonBookCommand
 */
export const de_PutPearsonBookCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
/**
 * deserializeAws_restJson1PutPearsonContextTemplateCommand
 */
export const de_PutPearsonContextTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
/**
 * deserializeAws_restJson1PutPearsonQuestionCommand
 */
export const de_PutPearsonQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'questionId': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
/**
 * deserializeAws_restJson1PutPearsonTemplateCommand
 */
export const de_PutPearsonTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
/**
 * deserializeAws_restJson1UpdatePearsonContextTemplateCommand
 */
export const de_UpdatePearsonContextTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.contextTemplate = _json(data);
    return contents;
};
/**
 * deserializeAws_restJson1UpdatePearsonContextTemplateQuestionCommand
 */
export const de_UpdatePearsonContextTemplateQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.question = de_PearsonContextTemplateQuestion(data, context);
    return contents;
};
/**
 * deserializeAws_restJson1CreateSafeProgramCommand
 */
export const de_CreateSafeProgramCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.safeProgram = _json(data);
    return contents;
};
/**
 * deserialize_Aws_restJson1CommandError
 */
const de_CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestError":
        case "com.codegrade.errors#BadRequestError":
            throw await de_BadRequestErrorRes(parsedOutput, context);
        case "InternalServerError":
        case "com.codegrade.errors#InternalServerError":
            throw await de_InternalServerErrorRes(parsedOutput, context);
        case "NotAuthenticatedError":
        case "com.codegrade.errors#NotAuthenticatedError":
            throw await de_NotAuthenticatedErrorRes(parsedOutput, context);
        case "NotAuthorizedError":
        case "com.codegrade.errors#NotAuthorizedError":
            throw await de_NotAuthorizedErrorRes(parsedOutput, context);
        case "NotFoundError":
        case "com.codegrade.errors#NotFoundError":
            throw await de_NotFoundErrorRes(parsedOutput, context);
        case "ValidationError":
        case "com.codegrade.errors#ValidationError":
            throw await de_ValidationErrorRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return throwDefaultError({
                output,
                parsedBody,
                errorCode
            });
    }
};
const throwDefaultError = withBaseException(__BaseException);
/**
 * deserializeAws_restJson1BadRequestErrorRes
 */
const de_BadRequestErrorRes = async (parsedOutput, context) => {
    const contents = map({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = take(data, {
        'description': __expectString,
        'message': __expectString,
        'reason': _ => de_BadRequestErrorReason(__expectUnion(_), context),
    });
    Object.assign(contents, doc);
    const exception = new BadRequestError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
/**
 * deserializeAws_restJson1InternalServerErrorRes
 */
const de_InternalServerErrorRes = async (parsedOutput, context) => {
    const contents = map({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = take(data, {
        'description': __expectString,
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new InternalServerError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
/**
 * deserializeAws_restJson1NotAuthenticatedErrorRes
 */
const de_NotAuthenticatedErrorRes = async (parsedOutput, context) => {
    const contents = map({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = take(data, {
        'description': __expectString,
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new NotAuthenticatedError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
/**
 * deserializeAws_restJson1NotAuthorizedErrorRes
 */
const de_NotAuthorizedErrorRes = async (parsedOutput, context) => {
    const contents = map({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = take(data, {
        'description': __expectString,
        'message': __expectString,
        'operation': __expectString,
        'resource': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new NotAuthorizedError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
/**
 * deserializeAws_restJson1NotFoundErrorRes
 */
const de_NotFoundErrorRes = async (parsedOutput, context) => {
    const contents = map({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = take(data, {
        'description': __expectString,
        'message': __expectString,
        'resource': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new NotFoundError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
/**
 * deserializeAws_restJson1ValidationErrorRes
 */
const de_ValidationErrorRes = async (parsedOutput, context) => {
    const contents = map({
        [_rI]: [, parsedOutput.headers[_xri]],
    });
    const data = parsedOutput.body;
    const doc = take(data, {
        'description': __expectString,
        'fieldList': _json,
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new ValidationError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
// se_AssignmentAssistantData omitted.
// se_AssistantData omitted.
// se_AssistantMessageUserContent omitted.
// se_AssistantStatus omitted.
/**
 * serializeAws_restJson1AutoTestAllowInternetStepInput
 */
const se_AutoTestAllowInternetStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
    });
};
// se_AutoTestCheckstyleStepInput omitted.
/**
 * serializeAws_restJson1AutoTestCodeStructureTestStepInput
 */
const se_AutoTestCodeStructureTestStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'file': [],
        'id': [],
        'name': [],
        'version': [],
    });
};
/**
 * serializeAws_restJson1AutoTestCodingQuestionStepInput
 */
const se_AutoTestCodingQuestionStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'name': [],
        'question': [],
        'starterCode': [],
        'studentFileName': [],
    });
};
/**
 * serializeAws_restJson1AutoTestConnectRubricStepInput
 */
const se_AutoTestConnectRubricStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'rubricRowId': [],
    });
};
// se_AutoTestCustomTestStepInput omitted.
// se_AutoTestDeductions omitted.
// se_AutoTestDescription omitted.
// se_AutoTestDoNotOverwriteCase omitted.
// se_AutoTestDoOverwriteCase omitted.
// se_AutoTestFlake8StepInput omitted.
// se_AutoTestInstallClangStepInput omitted.
// se_AutoTestInstallDotnetStepInput omitted.
// se_AutoTestInstallGccStepInput omitted.
// se_AutoTestInstallJavaStepInput omitted.
// se_AutoTestInstallNodeStepInput omitted.
// se_AutoTestInstallPythonStepInput omitted.
/**
 * serializeAws_restJson1AutoTestIoTestStepInput
 */
const se_AutoTestIoTestStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'name': [],
        'script': [],
    });
};
// se_AutoTestJavaCompileStepInput omitted.
// se_AutoTestJunit5StepInput omitted.
// se_AutoTestJunit5TestFile omitted.
// se_AutoTestMcqAnswers omitted.
// se_AutoTestMcqAnswersValue omitted.
// se_AutoTestMcqStepInput omitted.
// se_AutoTestNegativeMatchStepInput omitted.
// se_AutoTestOutputStepInput omitted.
// se_AutoTestOverwriteRubric omitted.
// se_AutoTestPositiveMatchStepInput omitted.
// se_AutoTestProgramStepInput omitted.
/**
 * serializeAws_restJson1AutoTestPromptEngineeringQuestionStepInput
 */
const se_AutoTestPromptEngineeringQuestionStepInput = (input, context) => {
    return take(input, {
        'answerFilename': [],
        'answerLanguage': [],
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'name': [],
        'question': [],
        'systemPrompt': [],
    });
};
// se_AutoTestPublishedSnapshotId omitted.
// se_AutoTestPytestStepInput omitted.
/**
 * serializeAws_restJson1AutoTestQuizStepInput
 */
const se_AutoTestQuizStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'fileName': [],
        'id': [],
        'runSingleQuestions': [],
    });
};
// se_AutoTestRegexMatchStepInput omitted.
// se_AutoTestRunIfCondition omitted.
/**
 * serializeAws_restJson1AutoTestRunIfStepInput
 */
const se_AutoTestRunIfStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'condition': _json,
        'id': [],
    });
};
/**
 * serializeAws_restJson1AutoTestRunInStepInput
 */
const se_AutoTestRunInStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'environment': [],
        'id': [],
    });
};
// se_AutoTestScriptStepInput omitted.
// se_AutoTestSelectAllQuestionAnswers omitted.
// se_AutoTestSelectAllQuestionAnswersValue omitted.
// se_AutoTestSelectAllQuestionAnswersValueHints omitted.
// se_AutoTestSelectAllQuestionStepInput omitted.
/**
 * serializeAws_restJson1AutoTestSetupConfigurationInput
 */
const se_AutoTestSetupConfigurationInput = (input, context) => {
    return take(input, {
        'steps': _ => se_AutoTestSetupStepsInput(_, context),
    });
};
/**
 * serializeAws_restJson1AutoTestSetupStepInput
 */
const se_AutoTestSetupStepInput = (input, context) => {
    return AutoTestSetupStepInput.visit(input, {
        installClang: value => ({ "installClang": _json(value) }),
        installDotnet: value => ({ "installDotnet": _json(value) }),
        installGcc: value => ({ "installGcc": _json(value) }),
        installJava: value => ({ "installJava": _json(value) }),
        installNode: value => ({ "installNode": _json(value) }),
        installPython: value => ({ "installPython": _json(value) }),
        script: value => ({ "script": _json(value) }),
        uploadFiles: value => ({ "uploadFiles": se_AutoTestUploadFilesStepInput(value, context) }),
        _: (name, value) => ({ name: value })
    });
};
/**
 * serializeAws_restJson1AutoTestSetupStepsInput
 */
const se_AutoTestSetupStepsInput = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_AutoTestSetupStepInput(entry, context);
    });
};
// se_AutoTestSimpleMatchStepInput omitted.
// se_AutoTestSimplePythonTestStepInput omitted.
/**
 * serializeAws_restJson1AutoTestSnapshotStepInput
 */
const se_AutoTestSnapshotStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
    });
};
// se_AutoTestSubstringMatchStepInput omitted.
/**
 * serializeAws_restJson1AutoTestTestConfigurationInput
 */
const se_AutoTestTestConfigurationInput = (input, context) => {
    return take(input, {
        'steps': _ => se_AutoTestTestStepsInput(_, context),
    });
};
/**
 * serializeAws_restJson1AutoTestTestHideStepInput
 */
const se_AutoTestTestHideStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'hideType': [],
        'id': [],
        'preposition': [],
        'when': [],
    });
};
/**
 * serializeAws_restJson1AutoTestTestStepInput
 */
const se_AutoTestTestStepInput = (input, context) => {
    return AutoTestTestStepInput.visit(input, {
        allowInternet: value => ({ "allowInternet": se_AutoTestAllowInternetStepInput(value, context) }),
        checkstyle: value => ({ "checkstyle": _json(value) }),
        codeStructureTest: value => ({ "codeStructureTest": se_AutoTestCodeStructureTestStepInput(value, context) }),
        codingQuestion: value => ({ "codingQuestion": se_AutoTestCodingQuestionStepInput(value, context) }),
        connectRubric: value => ({ "connectRubric": se_AutoTestConnectRubricStepInput(value, context) }),
        customTest: value => ({ "customTest": _json(value) }),
        flake8: value => ({ "flake8": _json(value) }),
        ioTest: value => ({ "ioTest": se_AutoTestIoTestStepInput(value, context) }),
        javaCompile: value => ({ "javaCompile": _json(value) }),
        junit5: value => ({ "junit5": _json(value) }),
        mcq: value => ({ "mcq": _json(value) }),
        negativeMatch: value => ({ "negativeMatch": _json(value) }),
        output: value => ({ "output": _json(value) }),
        positiveMatch: value => ({ "positiveMatch": _json(value) }),
        program: value => ({ "program": _json(value) }),
        promptEngineeringQuestion: value => ({ "promptEngineeringQuestion": se_AutoTestPromptEngineeringQuestionStepInput(value, context) }),
        pytest: value => ({ "pytest": _json(value) }),
        quiz: value => ({ "quiz": se_AutoTestQuizStepInput(value, context) }),
        regexMatch: value => ({ "regexMatch": _json(value) }),
        runIf: value => ({ "runIf": se_AutoTestRunIfStepInput(value, context) }),
        runIn: value => ({ "runIn": se_AutoTestRunInStepInput(value, context) }),
        selectAllQuestion: value => ({ "selectAllQuestion": _json(value) }),
        simpleMatch: value => ({ "simpleMatch": _json(value) }),
        simplePythonTest: value => ({ "simplePythonTest": _json(value) }),
        snapshot: value => ({ "snapshot": se_AutoTestSnapshotStepInput(value, context) }),
        substringMatch: value => ({ "substringMatch": _json(value) }),
        testHide: value => ({ "testHide": se_AutoTestTestHideStepInput(value, context) }),
        testTimeoutEach: value => ({ "testTimeoutEach": se_AutoTestTestTimeoutEachStepInput(value, context) }),
        testUploadFiles: value => ({ "testUploadFiles": se_AutoTestTestUploadFilesStepInput(value, context) }),
        weight: value => ({ "weight": se_AutoTestWeightStepInput(value, context) }),
        _: (name, value) => ({ name: value })
    });
};
/**
 * serializeAws_restJson1AutoTestTestStepsInput
 */
const se_AutoTestTestStepsInput = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_AutoTestTestStepInput(entry, context);
    });
};
/**
 * serializeAws_restJson1AutoTestTestTimeoutEachStepInput
 */
const se_AutoTestTestTimeoutEachStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'timeout': [],
    });
};
/**
 * serializeAws_restJson1AutoTestTestUploadFilesStepInput
 */
const se_AutoTestTestUploadFilesStepInput = (input, context) => {
    return take(input, {
        'description': _json,
        'files': _ => se_AutoTestUploadedFilesInput(_, context),
        'id': [],
        'name': [],
    });
};
/**
 * serializeAws_restJson1AutoTestUploadedFileInput
 */
const se_AutoTestUploadedFileInput = (input, context) => {
    return take(input, {
        'contents': context.base64Encoder,
        'id': [],
        'path': [],
    });
};
/**
 * serializeAws_restJson1AutoTestUploadedFilesInput
 */
const se_AutoTestUploadedFilesInput = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_AutoTestUploadedFileInput(entry, context);
    });
};
/**
 * serializeAws_restJson1AutoTestUploadFilesStepInput
 */
const se_AutoTestUploadFilesStepInput = (input, context) => {
    return take(input, {
        'description': _json,
        'files': _ => se_AutoTestUploadedFilesInput(_, context),
        'id': [],
        'name': [],
    });
};
/**
 * serializeAws_restJson1AutoTestWeightStepInput
 */
const se_AutoTestWeightStepInput = (input, context) => {
    return take(input, {
        'children': _ => se_AutoTestTestStepsInput(_, context),
        'id': [],
        'weight': _json,
    });
};
// se_Fraction omitted.
// se_EditorSessionSource omitted.
// se_EditorSessionSubmissionSource omitted.
// se_EditorSessionTemplateSource omitted.
// se_InputEditorDirectoryType omitted.
// se_InputFileType omitted.
// se_InputRegularFileType omitted.
// se_InstantiatePearsonQuestionMapping omitted.
// se_NumberOfAttempts omitted.
// se_PearsonBookTags omitted.
// se_PearsonContextTemplateQuestionReference omitted.
// se_PearsonMultipleChoiceQuestionAnswer omitted.
// se_PearsonMultipleChoiceQuestionAnswers omitted.
// se_PearsonMultipleChoiceQuestionData omitted.
// se_PearsonSelectAllQuestionAnswer omitted.
// se_PearsonSelectAllQuestionAnswerHints omitted.
// se_PearsonSelectAllQuestionAnswers omitted.
// se_PearsonSelectAllQuestionData omitted.
// se_PutPearsonCodingQuestionSource omitted.
// se_PutPearsonQuestionSource omitted.
// se_SafeProgramPearsonQuestionSource omitted.
// se_SafeProgramSingleQuizQuestionSource omitted.
// se_SafeProgramSource omitted.
// se_Unit omitted.
// de_AssignmentAssistantData omitted.
// de_Assistant omitted.
/**
 * deserializeAws_restJson1AssistantConversation
 */
const de_AssistantConversation = (output, context) => {
    return take(output, {
        'assistantId': __expectString,
        'conversationId': __expectString,
        'createdAt': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'owner': __expectString,
        'title': __expectString,
    });
};
/**
 * deserializeAws_restJson1AssistantConversations
 */
const de_AssistantConversations = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AssistantConversation(entry, context);
    });
    return retVal;
};
// de_AssistantData omitted.
/**
 * deserializeAws_restJson1AssistantMessage
 */
const de_AssistantMessage = (output, context) => {
    return take(output, {
        'assistantId': __expectString,
        'conversationId': __expectString,
        'createdAt': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'data': (_) => _json(__expectUnion(_)),
        'messageId': __expectString,
    });
};
// de_AssistantMessageAssistantContent omitted.
// de_AssistantMessageAssistantData omitted.
// de_AssistantMessageData omitted.
/**
 * deserializeAws_restJson1AssistantMessages
 */
const de_AssistantMessages = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AssistantMessage(entry, context);
    });
    return retVal;
};
// de_AssistantMessageStopMaxTokens omitted.
// de_AssistantMessageStopReason omitted.
// de_AssistantMessageUserContent omitted.
// de_AssistantMessageUserData omitted.
// de_Assistants omitted.
// de_AssistantStatus omitted.
// de_AutoInstallCodeStructureTestStepOutput omitted.
// de_AutoInstallFlake8StepOutput omitted.
// de_AutoInstallPytestStepOutput omitted.
// de_AutoInstallSimplePythonTestStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestAllowInternetStepOutput
 */
const de_AutoTestAllowInternetStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': __expectString,
    });
};
// de_AutoTestAutoInstallConfigurationOutput omitted.
// de_AutoTestAutoInstallStepOutput omitted.
// de_AutoTestAutoInstallStepsOutput omitted.
// de_AutoTestCheckstyleStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestCodeStructureTestStepOutput
 */
const de_AutoTestCodeStructureTestStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'file': __expectString,
        'id': __expectString,
        'name': __expectString,
        'version': __expectString,
    });
};
/**
 * deserializeAws_restJson1AutoTestCodingQuestionStepOutput
 */
const de_AutoTestCodingQuestionStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': __expectString,
        'name': __expectString,
        'question': __expectString,
        'starterCode': __expectString,
        'studentFileName': __expectString,
    });
};
/**
 * deserializeAws_restJson1AutoTestConfiguration
 */
const de_AutoTestConfiguration = (output, context) => {
    return take(output, {
        'assignmentId': __expectString,
        'publishedSnapshot': (_) => _json(__expectUnion(_)),
        'setup': _json,
        'test': (_) => de_AutoTestTestConfigurationOutput(_, context),
    });
};
/**
 * deserializeAws_restJson1AutoTestConnectRubricStepOutput
 */
const de_AutoTestConnectRubricStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': __expectString,
        'rubricRowId': __expectInt32,
    });
};
// de_AutoTestCopiedSnapshotSource omitted.
// de_AutoTestCustomTestStepOutput omitted.
// de_AutoTestDeductions omitted.
// de_AutoTestDescription omitted.
// de_AutoTestFlake8StepOutput omitted.
// de_AutoTestInstallClangStepOutput omitted.
// de_AutoTestInstallDotnetStepOutput omitted.
// de_AutoTestInstallGccStepOutput omitted.
// de_AutoTestInstallJavaStepOutput omitted.
// de_AutoTestInstallNodeStepOutput omitted.
// de_AutoTestInstallPythonStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestIoTestStepOutput
 */
const de_AutoTestIoTestStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': __expectString,
        'name': __expectString,
        'script': __expectString,
    });
};
// de_AutoTestJavaCompileStepOutput omitted.
// de_AutoTestJunit5StepOutput omitted.
// de_AutoTestJunit5TestFile omitted.
// de_AutoTestMcqAnswers omitted.
// de_AutoTestMcqAnswersValue omitted.
// de_AutoTestMcqStepOutput omitted.
// de_AutoTestNegativeMatchStepOutput omitted.
// de_AutoTestOutputStepOutput omitted.
// de_AutoTestPartialUploadedFileOutput omitted.
// de_AutoTestPartialUploadedFilesOutput omitted.
// de_AutoTestPositiveMatchStepOutput omitted.
// de_AutoTestProgramStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestPromptEngineeringQuestionStepOutput
 */
const de_AutoTestPromptEngineeringQuestionStepOutput = (output, context) => {
    return take(output, {
        'answerFilename': __expectString,
        'answerLanguage': __expectString,
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': __expectString,
        'name': __expectString,
        'question': __expectString,
        'systemPrompt': __expectString,
    });
};
/**
 * deserializeAws_restJson1AutoTestPublishedSnapshot
 */
const de_AutoTestPublishedSnapshot = (output, context) => {
    return take(output, {
        'assignmentId': __expectString,
        'createdAt': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'snapshotId': __expectString,
        'test': (_) => de_AutoTestRedactedTestConfigurationOutput(_, context),
    });
};
// de_AutoTestPublishedSnapshotId omitted.
// de_AutoTestPytestStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestQuizStepOutput
 */
const de_AutoTestQuizStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'fileName': __expectString,
        'id': __expectString,
        'runSingleQuestions': __expectBoolean,
    });
};
// de_AutoTestRanSnapshotSource omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedAllowInternetStepOutput
 */
const de_AutoTestRedactedAllowInternetStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': __expectString,
    });
};
// de_AutoTestRedactedBoolean omitted.
// de_AutoTestRedactedCaseSensitivity omitted.
// de_AutoTestRedactedCheckstyleStepOutput omitted.
// de_AutoTestRedactedCheckstyleVersion omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedCodeStructureTestStepOutput
 */
const de_AutoTestRedactedCodeStructureTestStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'file': (_) => _json(__expectUnion(_)),
        'id': __expectString,
        'name': __expectString,
        'version': (_) => _json(__expectUnion(_)),
    });
};
// de_AutoTestRedactedCodeStructureTestVersion omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedCodingQuestionStepOutput
 */
const de_AutoTestRedactedCodingQuestionStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': __expectString,
        'name': __expectString,
        'question': __expectString,
        'starterCode': __expectString,
        'studentFileName': __expectString,
    });
};
/**
 * deserializeAws_restJson1AutoTestRedactedConnectRubricStepOutput
 */
const de_AutoTestRedactedConnectRubricStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': __expectString,
        'rubricRowId': (_) => _json(__expectUnion(_)),
    });
};
// de_AutoTestRedactedCustomTestStepOutput omitted.
// de_AutoTestRedactedDeductions omitted.
// de_AutoTestRedactedFlake8StepOutput omitted.
// de_AutoTestRedactedFlake8Version omitted.
// de_AutoTestRedactedFraction omitted.
// de_AutoTestRedactedInteger omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedIoTestStepOutput
 */
const de_AutoTestRedactedIoTestStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': __expectString,
        'name': __expectString,
        'script': (_) => _json(__expectUnion(_)),
    });
};
// de_AutoTestRedactedJavaCompileStepOutput omitted.
// de_AutoTestRedactedJunit5StepOutput omitted.
// de_AutoTestRedactedJunit5TestFile omitted.
// de_AutoTestRedactedMcqAnswers omitted.
// de_AutoTestRedactedMcqAnswersValue omitted.
// de_AutoTestRedactedMcqStepOutput omitted.
// de_AutoTestRedactedNegativeMatchStepOutput omitted.
// de_AutoTestRedactedOutputStepOutput omitted.
// de_AutoTestRedactedPositiveDuration omitted.
// de_AutoTestRedactedPositiveMatchStepOutput omitted.
// de_AutoTestRedactedProgramStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedPromptEngineeringQuestionStepOutput
 */
const de_AutoTestRedactedPromptEngineeringQuestionStepOutput = (output, context) => {
    return take(output, {
        'answerFilename': __expectString,
        'answerLanguage': __expectString,
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': __expectString,
        'name': __expectString,
        'question': __expectString,
        'systemPrompt': __expectString,
    });
};
// de_AutoTestRedactedPytestStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedQuizStepOutput
 */
const de_AutoTestRedactedQuizStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'fileName': __expectString,
        'id': __expectString,
        'runSingleQuestions': __expectBoolean,
    });
};
// de_AutoTestRedactedRegexMatchStepOutput omitted.
// de_AutoTestRedactedRunIfCondition omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedRunIfStepOutput
 */
const de_AutoTestRedactedRunIfStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'condition': (_) => _json(__expectUnion(_)),
        'id': __expectString,
    });
};
/**
 * deserializeAws_restJson1AutoTestRedactedRunInStepOutput
 */
const de_AutoTestRedactedRunInStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'environment': __expectString,
        'id': __expectString,
    });
};
// de_AutoTestRedactedSelectAllQuestionAnswers omitted.
// de_AutoTestRedactedSelectAllQuestionAnswersValue omitted.
// de_AutoTestRedactedSelectAllQuestionAnswersValueHints omitted.
// de_AutoTestRedactedSelectAllQuestionStepOutput omitted.
// de_AutoTestRedactedSimpleMatchStepOutput omitted.
// de_AutoTestRedactedSimplePythonTestStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedSnapshotStepOutput
 */
const de_AutoTestRedactedSnapshotStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': __expectString,
    });
};
// de_AutoTestRedactedString omitted.
// de_AutoTestRedactedSubstringMatchStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedTestConfigurationOutput
 */
const de_AutoTestRedactedTestConfigurationOutput = (output, context) => {
    return take(output, {
        'steps': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
    });
};
/**
 * deserializeAws_restJson1AutoTestRedactedTestHideStepOutput
 */
const de_AutoTestRedactedTestHideStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'hideType': __expectString,
        'id': __expectString,
        'preposition': __expectString,
        'when': __expectString,
    });
};
/**
 * deserializeAws_restJson1AutoTestRedactedTestStepOutput
 */
const de_AutoTestRedactedTestStepOutput = (output, context) => {
    if (output.allowInternet != null) {
        return {
            allowInternet: de_AutoTestRedactedAllowInternetStepOutput(output.allowInternet, context)
        };
    }
    if (output.checkstyle != null) {
        return {
            checkstyle: _json(output.checkstyle)
        };
    }
    if (output.codeStructureTest != null) {
        return {
            codeStructureTest: de_AutoTestRedactedCodeStructureTestStepOutput(output.codeStructureTest, context)
        };
    }
    if (output.codingQuestion != null) {
        return {
            codingQuestion: de_AutoTestRedactedCodingQuestionStepOutput(output.codingQuestion, context)
        };
    }
    if (output.connectRubric != null) {
        return {
            connectRubric: de_AutoTestRedactedConnectRubricStepOutput(output.connectRubric, context)
        };
    }
    if (output.customTest != null) {
        return {
            customTest: _json(output.customTest)
        };
    }
    if (output.flake8 != null) {
        return {
            flake8: _json(output.flake8)
        };
    }
    if (output.ioTest != null) {
        return {
            ioTest: de_AutoTestRedactedIoTestStepOutput(output.ioTest, context)
        };
    }
    if (output.javaCompile != null) {
        return {
            javaCompile: _json(output.javaCompile)
        };
    }
    if (output.junit5 != null) {
        return {
            junit5: _json(output.junit5)
        };
    }
    if (output.mcq != null) {
        return {
            mcq: _json(output.mcq)
        };
    }
    if (output.negativeMatch != null) {
        return {
            negativeMatch: _json(output.negativeMatch)
        };
    }
    if (output.output != null) {
        return {
            output: _json(output.output)
        };
    }
    if (output.positiveMatch != null) {
        return {
            positiveMatch: _json(output.positiveMatch)
        };
    }
    if (output.program != null) {
        return {
            program: _json(output.program)
        };
    }
    if (output.promptEngineeringQuestion != null) {
        return {
            promptEngineeringQuestion: de_AutoTestRedactedPromptEngineeringQuestionStepOutput(output.promptEngineeringQuestion, context)
        };
    }
    if (output.pytest != null) {
        return {
            pytest: _json(output.pytest)
        };
    }
    if (output.quiz != null) {
        return {
            quiz: de_AutoTestRedactedQuizStepOutput(output.quiz, context)
        };
    }
    if (output.regexMatch != null) {
        return {
            regexMatch: _json(output.regexMatch)
        };
    }
    if (output.runIf != null) {
        return {
            runIf: de_AutoTestRedactedRunIfStepOutput(output.runIf, context)
        };
    }
    if (output.runIn != null) {
        return {
            runIn: de_AutoTestRedactedRunInStepOutput(output.runIn, context)
        };
    }
    if (output.selectAllQuestion != null) {
        return {
            selectAllQuestion: _json(output.selectAllQuestion)
        };
    }
    if (output.simpleMatch != null) {
        return {
            simpleMatch: _json(output.simpleMatch)
        };
    }
    if (output.simplePythonTest != null) {
        return {
            simplePythonTest: _json(output.simplePythonTest)
        };
    }
    if (output.snapshot != null) {
        return {
            snapshot: de_AutoTestRedactedSnapshotStepOutput(output.snapshot, context)
        };
    }
    if (output.substringMatch != null) {
        return {
            substringMatch: _json(output.substringMatch)
        };
    }
    if (output.testHide != null) {
        return {
            testHide: de_AutoTestRedactedTestHideStepOutput(output.testHide, context)
        };
    }
    if (output.testTimeoutEach != null) {
        return {
            testTimeoutEach: de_AutoTestRedactedTestTimeoutEachStepOutput(output.testTimeoutEach, context)
        };
    }
    if (output.testUploadFiles != null) {
        return {
            testUploadFiles: _json(output.testUploadFiles)
        };
    }
    if (output.weight != null) {
        return {
            weight: de_AutoTestRedactedWeightStepOutput(output.weight, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
/**
 * deserializeAws_restJson1AutoTestRedactedTestStepsOutput
 */
const de_AutoTestRedactedTestStepsOutput = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AutoTestRedactedTestStepOutput(__expectUnion(entry), context);
    });
    return retVal;
};
/**
 * deserializeAws_restJson1AutoTestRedactedTestTimeoutEachStepOutput
 */
const de_AutoTestRedactedTestTimeoutEachStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': __expectString,
        'timeout': (_) => _json(__expectUnion(_)),
    });
};
// de_AutoTestRedactedTestUploadFilesStepOutput omitted.
// de_AutoTestRedactedUploadedFilesOutput omitted.
/**
 * deserializeAws_restJson1AutoTestRedactedWeightStepOutput
 */
const de_AutoTestRedactedWeightStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestRedactedTestStepsOutput(_, context),
        'id': __expectString,
        'weight': (_) => _json(__expectUnion(_)),
    });
};
// de_AutoTestRedactedWhitespacesPolicy omitted.
// de_AutoTestRegexMatchStepOutput omitted.
// de_AutoTestRunIfCondition omitted.
/**
 * deserializeAws_restJson1AutoTestRunIfStepOutput
 */
const de_AutoTestRunIfStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'condition': _json,
        'id': __expectString,
    });
};
/**
 * deserializeAws_restJson1AutoTestRunInStepOutput
 */
const de_AutoTestRunInStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'environment': __expectString,
        'id': __expectString,
    });
};
// de_AutoTestScriptStepOutput omitted.
// de_AutoTestSelectAllQuestionAnswers omitted.
// de_AutoTestSelectAllQuestionAnswersValue omitted.
// de_AutoTestSelectAllQuestionAnswersValueHints omitted.
// de_AutoTestSelectAllQuestionStepOutput omitted.
// de_AutoTestSetupConfigurationOutput omitted.
// de_AutoTestSetupMetadata omitted.
// de_AutoTestSetupStepOutput omitted.
// de_AutoTestSetupStepsOutput omitted.
// de_AutoTestSimpleMatchStepOutput omitted.
// de_AutoTestSimplePythonTestStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestSnapshot
 */
const de_AutoTestSnapshot = (output, context) => {
    return take(output, {
        'assignmentId': __expectString,
        'autoInstall': _json,
        'createdAt': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'setup': _json,
        'snapshotId': __expectString,
        'source': (_) => _json(__expectUnion(_)),
        'test': (_) => de_AutoTestTestConfigurationOutput(_, context),
    });
};
// de_AutoTestSnapshotBuildProgram omitted.
// de_AutoTestSnapshotSource omitted.
/**
 * deserializeAws_restJson1AutoTestSnapshotStepOutput
 */
const de_AutoTestSnapshotStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': __expectString,
    });
};
/**
 * deserializeAws_restJson1AutoTestSnapshotSummaries
 */
const de_AutoTestSnapshotSummaries = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AutoTestSnapshotSummary(entry, context);
    });
    return retVal;
};
/**
 * deserializeAws_restJson1AutoTestSnapshotSummary
 */
const de_AutoTestSnapshotSummary = (output, context) => {
    return take(output, {
        'assignmentId': __expectString,
        'createdAt': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'snapshotId': __expectString,
        'source': (_) => _json(__expectUnion(_)),
    });
};
// de_AutoTestSubstringMatchStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestTestConfigurationOutput
 */
const de_AutoTestTestConfigurationOutput = (output, context) => {
    return take(output, {
        'steps': (_) => de_AutoTestTestStepsOutput(_, context),
    });
};
/**
 * deserializeAws_restJson1AutoTestTestHideStepOutput
 */
const de_AutoTestTestHideStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'hideType': __expectString,
        'id': __expectString,
        'preposition': __expectString,
        'when': __expectString,
    });
};
/**
 * deserializeAws_restJson1AutoTestTestStepOutput
 */
const de_AutoTestTestStepOutput = (output, context) => {
    if (output.allowInternet != null) {
        return {
            allowInternet: de_AutoTestAllowInternetStepOutput(output.allowInternet, context)
        };
    }
    if (output.checkstyle != null) {
        return {
            checkstyle: _json(output.checkstyle)
        };
    }
    if (output.codeStructureTest != null) {
        return {
            codeStructureTest: de_AutoTestCodeStructureTestStepOutput(output.codeStructureTest, context)
        };
    }
    if (output.codingQuestion != null) {
        return {
            codingQuestion: de_AutoTestCodingQuestionStepOutput(output.codingQuestion, context)
        };
    }
    if (output.connectRubric != null) {
        return {
            connectRubric: de_AutoTestConnectRubricStepOutput(output.connectRubric, context)
        };
    }
    if (output.customTest != null) {
        return {
            customTest: _json(output.customTest)
        };
    }
    if (output.flake8 != null) {
        return {
            flake8: _json(output.flake8)
        };
    }
    if (output.ioTest != null) {
        return {
            ioTest: de_AutoTestIoTestStepOutput(output.ioTest, context)
        };
    }
    if (output.javaCompile != null) {
        return {
            javaCompile: _json(output.javaCompile)
        };
    }
    if (output.junit5 != null) {
        return {
            junit5: _json(output.junit5)
        };
    }
    if (output.mcq != null) {
        return {
            mcq: _json(output.mcq)
        };
    }
    if (output.negativeMatch != null) {
        return {
            negativeMatch: _json(output.negativeMatch)
        };
    }
    if (output.output != null) {
        return {
            output: _json(output.output)
        };
    }
    if (output.positiveMatch != null) {
        return {
            positiveMatch: _json(output.positiveMatch)
        };
    }
    if (output.program != null) {
        return {
            program: _json(output.program)
        };
    }
    if (output.promptEngineeringQuestion != null) {
        return {
            promptEngineeringQuestion: de_AutoTestPromptEngineeringQuestionStepOutput(output.promptEngineeringQuestion, context)
        };
    }
    if (output.pytest != null) {
        return {
            pytest: _json(output.pytest)
        };
    }
    if (output.quiz != null) {
        return {
            quiz: de_AutoTestQuizStepOutput(output.quiz, context)
        };
    }
    if (output.regexMatch != null) {
        return {
            regexMatch: _json(output.regexMatch)
        };
    }
    if (output.runIf != null) {
        return {
            runIf: de_AutoTestRunIfStepOutput(output.runIf, context)
        };
    }
    if (output.runIn != null) {
        return {
            runIn: de_AutoTestRunInStepOutput(output.runIn, context)
        };
    }
    if (output.selectAllQuestion != null) {
        return {
            selectAllQuestion: _json(output.selectAllQuestion)
        };
    }
    if (output.simpleMatch != null) {
        return {
            simpleMatch: _json(output.simpleMatch)
        };
    }
    if (output.simplePythonTest != null) {
        return {
            simplePythonTest: _json(output.simplePythonTest)
        };
    }
    if (output.snapshot != null) {
        return {
            snapshot: de_AutoTestSnapshotStepOutput(output.snapshot, context)
        };
    }
    if (output.substringMatch != null) {
        return {
            substringMatch: _json(output.substringMatch)
        };
    }
    if (output.testHide != null) {
        return {
            testHide: de_AutoTestTestHideStepOutput(output.testHide, context)
        };
    }
    if (output.testTimeoutEach != null) {
        return {
            testTimeoutEach: de_AutoTestTestTimeoutEachStepOutput(output.testTimeoutEach, context)
        };
    }
    if (output.testUploadFiles != null) {
        return {
            testUploadFiles: _json(output.testUploadFiles)
        };
    }
    if (output.weight != null) {
        return {
            weight: de_AutoTestWeightStepOutput(output.weight, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
/**
 * deserializeAws_restJson1AutoTestTestStepsOutput
 */
const de_AutoTestTestStepsOutput = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AutoTestTestStepOutput(__expectUnion(entry), context);
    });
    return retVal;
};
/**
 * deserializeAws_restJson1AutoTestTestTimeoutEachStepOutput
 */
const de_AutoTestTestTimeoutEachStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': __expectString,
        'timeout': __expectInt32,
    });
};
// de_AutoTestTestUploadFilesStepOutput omitted.
// de_AutoTestUploadedFileOutput omitted.
// de_AutoTestUploadedFilesOutput omitted.
// de_AutoTestUploadFilesStepOutput omitted.
/**
 * deserializeAws_restJson1AutoTestWeightStepOutput
 */
const de_AutoTestWeightStepOutput = (output, context) => {
    return take(output, {
        'children': (_) => de_AutoTestTestStepsOutput(_, context),
        'id': __expectString,
        'weight': _json,
    });
};
// de_Fraction omitted.
// de_User omitted.
/**
 * deserializeAws_restJson1EditorFileList
 */
const de_EditorFileList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_EditorFileType(__expectUnion(entry), context);
    });
    return retVal;
};
/**
 * deserializeAws_restJson1EditorFileType
 */
const de_EditorFileType = (output, context) => {
    if (output.directory != null) {
        return {
            directory: de_OutputEditorDirectoryType(output.directory, context)
        };
    }
    if (output.regular != null) {
        return {
            regular: _json(__expectUnion(output.regular))
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
/**
 * deserializeAws_restJson1EditorSession
 */
const de_EditorSession = (output, context) => {
    return take(output, {
        'assignmentId': __expectString,
        'createdAt': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'fileTreeId': __expectString,
        'id': __expectString,
        'name': __expectString,
        'updatedAt': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'userId': __expectString,
    });
};
// de_EditorSessionReference omitted.
/**
 * deserializeAws_restJson1EditorSessions
 */
const de_EditorSessions = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_EditorSession(entry, context);
    });
    return retVal;
};
// de_OuptutRegularFileType omitted.
/**
 * deserializeAws_restJson1OutputEditorDirectoryType
 */
const de_OutputEditorDirectoryType = (output, context) => {
    return take(output, {
        'children': (_) => de_EditorFileList(_, context),
    });
};
/**
 * deserializeAws_restJson1OutputEditorFile
 */
const de_OutputEditorFile = (output, context) => {
    return take(output, {
        'assignmentId': __expectString,
        'editorSessionId': __expectString,
        'fileType': (_) => de_EditorFileType(__expectUnion(_), context),
        'path': __expectString,
    });
};
// de_OutputRegularBinaryFileType omitted.
// de_OutputRegularQuizFileType omitted.
// de_OutputRegularTextFileType omitted.
// de_SubmissionReference omitted.
/**
 * deserializeAws_restJson1BadRequestErrorReason
 */
const de_BadRequestErrorReason = (output, context) => {
    if (output.ignoreNonInteractedQuestions != null) {
        return {
            ignoreNonInteractedQuestions: _json(output.ignoreNonInteractedQuestions)
        };
    }
    if (output.inexplicitRubricOverwrite != null) {
        return {
            inexplicitRubricOverwrite: _json(output.inexplicitRubricOverwrite)
        };
    }
    if (output.invalidParam != null) {
        return {
            invalidParam: de_InvalidParamErrorReason(output.invalidParam, context)
        };
    }
    if (output.invalidState != null) {
        return {
            invalidState: _json(output.invalidState)
        };
    }
    if (output.unknownEnumType != null) {
        return {
            unknownEnumType: de_UnknownEnumTypeErrorReason(output.unknownEnumType, context)
        };
    }
    if (output.wrongItemCount != null) {
        return {
            wrongItemCount: de_WrongItemCountErrorReason(output.wrongItemCount, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
/**
 * deserializeAws_restJson1FoundUnknownEnumType
 */
const de_FoundUnknownEnumType = (output, context) => {
    return take(output, {
        'type': __expectString,
        'value': (_) => de_Document(_, context),
    });
};
// de_IgnoreNonInteractedQuestions omitted.
// de_InexplicitRubricOverwriteReason omitted.
/**
 * deserializeAws_restJson1InvalidParamErrorReason
 */
const de_InvalidParamErrorReason = (output, context) => {
    return take(output, {
        'error': __expectString,
        'name': __expectString,
        'value': (_) => de_Document(_, context),
    });
};
// de_InvalidStateErrorReason omitted.
/**
 * deserializeAws_restJson1UnknownEnumTypeErrorReason
 */
const de_UnknownEnumTypeErrorReason = (output, context) => {
    return take(output, {
        'found': (_) => de_FoundUnknownEnumType(_, context),
    });
};
// de_ValidationErrorField omitted.
// de_ValidationErrorFieldList omitted.
/**
 * deserializeAws_restJson1WrongItemCountErrorReason
 */
const de_WrongItemCountErrorReason = (output, context) => {
    return take(output, {
        'found': (_) => de_DocumentList(_, context),
        'maximumAllowed': __expectInt32,
        'minimumAllowed': __expectInt32,
        'what': __expectString,
    });
};
// de_NumberOfAttempts omitted.
/**
 * deserializeAws_restJson1PearsonCodingQuestionData
 */
const de_PearsonCodingQuestionData = (output, context) => {
    return take(output, {
        'autoTestSteps': (_) => de_Document(_, context),
        'correctAnswer': __expectString,
        'description': __expectString,
        'filename': __expectString,
        'template': __expectString,
    });
};
// de_PearsonContextTemplate omitted.
/**
 * deserializeAws_restJson1PearsonContextTemplateQuestion
 */
const de_PearsonContextTemplateQuestion = (output, context) => {
    return take(output, {
        'data': (_) => de_PearsonQuestionData(__expectUnion(_), context),
        'enabled': __expectBoolean,
        'name': __expectString,
        'questionId': __expectString,
    });
};
// de_PearsonContextTemplateQuestionSummaries omitted.
// de_PearsonContextTemplateQuestionSummary omitted.
// de_PearsonMultipleChoiceQuestionAnswer omitted.
// de_PearsonMultipleChoiceQuestionAnswers omitted.
// de_PearsonMultipleChoiceQuestionData omitted.
/**
 * deserializeAws_restJson1PearsonQuestionData
 */
const de_PearsonQuestionData = (output, context) => {
    if (output.coding != null) {
        return {
            coding: de_PearsonCodingQuestionData(output.coding, context)
        };
    }
    if (output.multipleChoice != null) {
        return {
            multipleChoice: _json(output.multipleChoice)
        };
    }
    if (output.selectAll != null) {
        return {
            selectAll: _json(output.selectAll)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
// de_PearsonSelectAllQuestionAnswer omitted.
// de_PearsonSelectAllQuestionAnswerHints omitted.
// de_PearsonSelectAllQuestionAnswers omitted.
// de_PearsonSelectAllQuestionData omitted.
// de_SafeProgram omitted.
/**
 * deserializeAws_restJson1DocumentList
 */
const de_DocumentList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_Document(entry, context);
    });
    return retVal;
};
/**
 * deserializeAws_restJson1Document
 */
const de_Document = (output, context) => {
    return output;
};
// de_Unit omitted.
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
// Encode Uint8Array data into string with utf-8.
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then(body => context.utf8Encoder(body));
const _aI = "assignmentId";
const _nT = "nextToken";
const _pS = "pageSize";
const _rI = "requestId";
const _xnt = "x-next-token";
const _xps = "x-page-size";
const _xri = "x-request-id";
